import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      content: "عضویت در انجمن علمی کامپیوتر بهترین تجربه دانشگاهی من بود. فرصت‌های زیادی برای یادگیری و شبکه‌سازی پیدا کردم.",
      author: "سارا محمدی",
      role: "دانشجوی مهندسی کامپیوتر",
      gender: "female"
    },
    {
      id: 2,
      content: "انجمن علمی برق به من کمک کرد تا مهارت‌های عملی خود را تقویت کنم و در مسابقات ملی شرکت کنم و مقام کسب کنم.",
      author: "رضا کریمی",
      role: "دانشجوی مهندسی برق",
      gender: "male"
    },
    {
      id: 3,
      content: "فعالیت در انجمن علمی عمران به من کمک کرد تا با صنعت ارتباط برقرار کنم و شغل مورد علاقه خود را پیدا کنم.",
      author: "زهرا احمدی",
      role: "دانشجوی مهندسی عمران",
      gender: "female"
    },
    {
      id: 4,
      content: "انجمن‌های علمی محیطی عالی برای رشد شخصی و حرفه‌ای فراهم می‌کنند. به همه دانشجویان توصیه می‌کنم عضو شوند.",
      author: "امیر حسینی",
      role: "دانشجوی مهندسی مکانیک",
      gender: "male"
    }
  ];

  return (
    <section className="testimonials" id="testimonials">
      <div className="container">
        <div className="section-title">
          <h2>نظرات دانشجویان</h2>
          <p>تجربیات دانشجویان از انجمن‌های علمی دانشگاه شمال</p>
        </div>
        <div className="testimonials-slider">
          {testimonials.map(testimonial => (
            <div key={testimonial.id} className="testimonial-card">
              <div className="testimonial-content">
                <i className="fas fa-quote-right quote-icon"></i>
                <p>{testimonial.content}</p>
              </div>
              <div className="testimonial-author">
                <div className="author-avatar">
                  <div className={`avatar-circle ${testimonial.gender}`}>
                    <div className="avatar-icon">
                      <i className="fas fa-user"></i>
                    </div>
                  </div>
                </div>
                <div className="author-info">
                  <h4>{testimonial.author}</h4>
                  <p>{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;